import { ICalendarEventModel } from "../models/calendarEventModel";
import styles from "./EventDetails.module.scss";
import { RenderWhen } from "../../../../common/infrastructure/components/RenderWhen";
import { DefaultButton } from "../../../../common/components/button/defaultButton/DefaultButton";
import { EventDetailsContent } from "./EventDetailsContent";
import { useEventDetails } from "../hooks/useEventDetails";

interface IEventDetails {
  currentEvent?: ICalendarEventModel;
  responsibleForUsersIds?: number[];
  onEventSignUp: (eventId?: number) => void;
}

export const EventDetails = (props: IEventDetails) => {
  const {
    contentProps,
    canMakeReservation,
    makeReservationButtonLabel,
    onMakeReservationClick,
    showManageReservations,
    onManageReservationsClick,
    showNotTakingPlace,
    showContactStudio,
    showContactUsNote,
    onContactStudioClick,
  } = useEventDetails(props);

  return (
    <div className={styles.details}>
      <EventDetailsContent {...contentProps} />

      <div className={styles.actions}>
        {/* Can make reservation */}
        <RenderWhen condition={canMakeReservation}>
          <DefaultButton
            onClick={onMakeReservationClick}
            label={makeReservationButtonLabel}
            design="secondary"
            width="100%"
          />
        </RenderWhen>

        {/* Manage existing reservations */}
        <RenderWhen condition={showManageReservations}>
          <DefaultButton
            onClick={onManageReservationsClick}
            label={"Управление на резервациите"}
            design="secondary"
            width="100%"
          />
        </RenderWhen>

        {/* Class will not take place */}
        <RenderWhen condition={showNotTakingPlace}>
          <p className={styles.actions_note}>Този клас няма да се проведе.</p>
        </RenderWhen>

        {/* Fallback: contact studio */}
        <RenderWhen condition={showContactStudio}>
          <RenderWhen condition={showContactUsNote}>
            <p className={styles.actions_note}>
              За резервация за този клас, моля свържете се директно с нас.
            </p>
          </RenderWhen>
          <DefaultButton
            onClick={onContactStudioClick}
            label={"Свържи се с обекта"}
            design="secondary"
            width="100%"
          />
        </RenderWhen>
      </div>
    </div>
  );
};
